/**
 * Fonts a client can choose. A short fixed list rather than a free-text
 * stylesheet link: each entry is known to load and render well.
 */
export interface FontOption {
  /** Stored value and CSS font-family name. */
  name: string;
  /** Google Fonts family parameter; null for fonts the app already loads. */
  google: string | null;
}

export const FONT_OPTIONS: FontOption[] = [
  { name: 'Outfit', google: null }, // the app's own font
  { name: 'Inter', google: null },
  { name: 'Roboto', google: 'Roboto:wght@300;400;500;700' },
  { name: 'Open Sans', google: 'Open+Sans:wght@300;400;600;700' },
  { name: 'Lato', google: 'Lato:wght@300;400;700' },
  { name: 'Poppins', google: 'Poppins:wght@300;400;500;600;700' },
  { name: 'Montserrat', google: 'Montserrat:wght@300;400;500;600;700' },
  { name: 'Nunito', google: 'Nunito:wght@300;400;600;700' },
  { name: 'Source Sans 3', google: 'Source+Sans+3:wght@300;400;600;700' },
  { name: 'Merriweather', google: 'Merriweather:wght@300;400;700' },
];

export function fontOption(name: string | null | undefined): FontOption | null {
  if (!name) return null;
  return FONT_OPTIONS.find((f) => f.name.toLowerCase() === name.trim().toLowerCase()) ?? null;
}

/** CSS font-family value for a chosen font, with the app's fallbacks. */
export function fontStack(name: string): string {
  return `'${name}', 'Outfit', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif`;
}

export function fontStylesheet(option: FontOption): string | null {
  return option.google ? `https://fonts.googleapis.com/css2?family=${option.google}&display=swap` : null;
}
